import { TwContainer } from '~/lib/TwContainer';
import list from '~/../public/tech.json';
import { Flex, Image } from '@mantine/core';

export const SectionFour = () => {
	return (
		<section className="bg-white">
			<TwContainer className="md:pb-20 pb-12 pt-4 px-8 grid gap-12">
				<div className={'col-span-full flex flex-col mx-auto  text-center gap-2'}>
					<h1 className="font-semibold text-primary text-5xl max-w-3xl font-saira">Technology we use</h1>
					<div className="max-w-2xl text-gray-700 font-inter">
						At Champtek, we use a variety of modern and innovative technologies to develop software products that meet the evolving needs of our
						clients.
					</div>
				</div>
				<Flex
					wrap={'wrap'}
					justify={'center'}
					gap={'xl'}>
					{Object.keys(list).map((key) => (
						<Image
							className={'w-fit'}
							key={key}
							mah={56}
							fit={'contain'}
							alt={key}
							// @ts-ignore
							src={list[key]}
						/>
					))}
				</Flex>
			</TwContainer>
		</section>
	);
};
